import View from './View'
import { ease } from './helpers/EaseHelper'
import { updateSpriteSheet } from './helpers/DOMHelper'

const COUNT_FRAME_MAX = 35
const STATE_SHOW = 'menu-button--show'
const STATE_BEFORE_HIDE = 'menu-button--before-hide'
const STATE_HIDE = 'menu-button--hide'
/**
 * class MenuButton
 */
class MenuButton extends View {

  constructor (el, onStateChange = () => {}) {
    super(el, onStateChange)
    this.state = STATE_HIDE
    this.line = this.view.querySelector('.menu-button__line')
    this.view.addEventListener('mouseover', () => this.over())
    this.view.addEventListener('mouseout', () => this.out())
  }

  get currentLineFrame () {
    return parseFloat(this.line.style.backgroundPositionX) / -100
  }

  showHandler (resolve) {
    if (this.state === STATE_SHOW) return
    ease({ value: 0 })
      .to({ value: COUNT_FRAME_MAX - 1 }, 1000)
      .onStart(o => this.state = STATE_SHOW)
      .onUpdate(o => { updateSpriteSheet(this.view, '100px', o.value) })
      .onComplete(() => resolve())
      .start()
    ease({ value: 0 })
      .to({ value: (COUNT_FRAME_MAX - 1) * 0.5 }, 1000)
      .onUpdate(o => { updateSpriteSheet(this.line, '100px', o.value) })
      .start()
  }

  hideHandler (resolve) {
    if (this.state === STATE_HIDE) return
    this.state = STATE_BEFORE_HIDE
    ease({ value: COUNT_FRAME_MAX - 1})
      .to({ value: 0 }, 1000)
      .onUpdate(o => { updateSpriteSheet(this.view, '100px', o.value) })
      .onComplete(() => {
        this.state = STATE_HIDE
        resolve()
      })
      .start()
    ease({ value: this.currentLineFrame })
      .to({ value: COUNT_FRAME_MAX - 1 }, 1000)
      .onUpdate(o => { updateSpriteSheet(this.line, '100px', o.value) })
      .start()
  }

  over () {
    if (this.state === STATE_HIDE || this.state === STATE_BEFORE_HIDE) return
    ease({ value: this.currentLineFrame })
      .to({ value: COUNT_FRAME_MAX - 1 }, 400)
      .onUpdate(o => { updateSpriteSheet(this.line, '100px', o.value) })
      .start()
  }

  out () {
    if (this.state === STATE_HIDE || this.state === STATE_BEFORE_HIDE) return
    ease({ value: 0 })
      .to({ value: (COUNT_FRAME_MAX - 1) * 0.5 }, 400)
      .onUpdate(o => { updateSpriteSheet(this.line, '100px', o.value) })
      .start()
  }

}
export default MenuButton


// WEBPACK FOOTER //
// ./src/scripts/MenuButton.js